module.exports = __webpack_public_path__ + "img/icon-qr-code.3e24fe15.svg";